import type { IAdViewManaged } from "@finn-no/adview-provider-frontend-types";
import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";

type Props = {
  fuel: IAdViewManaged | undefined;
};

export const Fuel = ({ fuel }: Props) => {
  const { i18n } = useLingui();

  if (fuel == null) {
    return null;
  }

  const fuelLabel = i18n._({
    id: "itemPageLayout.common.fuel.label",
    message: "Fuel",
    comment: "'Fuel' label in ad section summary",
  });

  return <FieldValuePair field={fuelLabel} value={fuel.value} />;
};
